import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Customer, Boat } from '../models';
import { CustomerFilter } from '../models/dtos/customer-filter';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { CustomerFilterListDTO } from '../models/dtos/customerFilterListDTO';
import { CustomerDependentDTO } from '../models/dtos/customer/customerDependentDTO';
import { CustomerBasicInfoDTO } from '../models/dtos/customer/customerBasicInfoDTO';

@Injectable()
export class CustomerService {




  constructor(private http: HttpClient) {}


  getServicesCustomerPriceFree(filter): Observable<any[]> {
    return this.http.post(environment.apiHost + '/secure/service-customer/readjustment/price-free', filter)
        .pipe(map((response: any) => response.data.readjustmentsPriceFree as any[]));
}

  getAll(campos?: string): Observable<Customer[]> {
    if (campos == undefined) {
      campos = '';
    }
    let headers = new HttpHeaders();
    headers = headers.set('campos', campos);
    return this.http
      .get(environment.apiHost + '/secure/customers/', { headers: headers })
      .pipe(map((response: any) => response.data.customers as Customer[]));
  }

  getServiceReportCustomers(customerFilter): Observable<Customer[]> {
    return this.http
      .post(environment.apiHost + '/secure/customers/e', customerFilter)
      .pipe(map((response: any) => response.data.customers as Customer[]));
  }

  getCustomerFilterList(): Observable<CustomerFilterListDTO[]> {
    return this.http
      .get(environment.apiHost + '/secure/customers/filter-list/')
      .pipe(
        map(
          (response: any) => response.data.customers as CustomerFilterListDTO[]
        )
      );
  }

  getAllCustomerActiveSimple(): Observable<any[]> {
    return this.http
      .get(environment.apiHost + '/secure/customers/customer-to-sale')
      .pipe(map((response: any) => response.data.customers));
  }

  getCustomerByBoatFilterList(
    boatId: number
  ): Observable<CustomerFilterListDTO[]> {
    return this.http
      .get(`${environment.apiHost}/secure/customers/boat/${boatId}/filter-list`)
      .pipe(
        map(
          (response: any) => response.data.customers as CustomerFilterListDTO[]
        )
      );
  }

  getPeriodicalServiceInUse(): Observable<CustomerFilterListDTO[]> {
    return this.http
      .get(
        environment.apiHost +
          '/secure/customers/periodical-services-in-use/price-free'
      )
      .pipe(
        map(
          (response: any) =>
            response.data
              .customersWithPeriodicalServicesInUse as CustomerFilterListDTO[]
        )
      );
  }

  getPeriodicalCustomerServiceInUse(): Observable<CustomerFilterListDTO[]> {
    return this.http
      .get(
        environment.apiHost +
          '/secure/customers/periodical-customer-services-in-use/price-free'
      )
      .pipe(
        map(
          (response: any) =>
            response.data
              .customersWithPeriodicalServicesInUse as CustomerFilterListDTO[]
        )
      );
  }

  getAllWithBoats(): Observable<Customer[]> {
    return this.http
      .get(environment.apiHost + '/secure/customers/has-boats/')
      .pipe(map((response: any) => response.data.customers as Customer[]));
  }
  getAllOwners(): Observable<Customer[]> {
    return this.http
      .get(environment.apiHost + '/secure/customers/owners-only')
      .pipe(map((response: any) => response.data.customers as Customer[]));
  }

  getByServiceDeskCustomer(): Observable<Customer> {
    return this.http
      .get(environment.apiHost + '/secure/customer/serviceDesk')
      .pipe(map((response: any) => response.data.customer));
  }

  getAllSimple(): Observable<Customer[]> {
    return this.http
      .get(environment.apiHost + '/secure/customers/simple')
      .pipe(map((response: any) => response.data.customers));
  }

  getAllSimpleV2(): Observable<Customer[]> {
    return this.http
      .get(environment.apiHost + '/api-customer/customer/id-name-active')
      .pipe(
        map((response: any) =>
          Array.isArray(response) ? response : (response?.data?.customers ?? [])
        )
      );
  }

  getAllSimpleOnlyActive(): Observable<Customer[]> {
    return this.getAllSimpleV2().pipe(
      map((data) => data.filter((c) => c.active === undefined || c.active))
    );
  }

  getCustomersBasicInfo(): Observable<CustomerBasicInfoDTO[]> {
    return this.http
      .get(environment.apiHost + '/secure/customers/basicinfo')
      .pipe(map((response: any) => response.data.customers as CustomerBasicInfoDTO[]));
  }

  getAllOwnerOnlySimple(): Observable<any[]> {
    return this.http
      .get(environment.apiHost + '/secure/customers/owners-only-simple')
      .pipe(map((response: any) => response.data.customers));
  }

  getByEmailAndMarinaId(body: String): Observable<Customer> {
    return this.http
      .put(environment.apiHost + '/secure/customer/email/', body)
      .pipe(map((response: any) => response.data.customer));
  }

  getById(id: number): Observable<Customer> {
    return this.http
      .get(environment.apiHost + '/secure/customer/' + id)
      .pipe(map((response: any) => response.data.customer));
  }

  getTitlePropertiesByCustomerId(id: number):Observable<any>{
    return this.http
    .get(environment.apiHost + '/api-core/secure/securities-property/get-title-by-customer-id/' + id)
    .pipe(map((response: any) => response));
  }

  getTitlePropertiesByMarinaId():Observable<any>{
    return this.http
    .get(environment.apiHost + '/api-core/secure/securities-property/get-title-by-marina-id')
    .pipe(map((response: any) => response));
  }

  getBoats(id: number): Observable<Boat[]> {
    return this.http
      .get(environment.apiHost + '/secure/customer/boats/' + id)
      .pipe(map((response: any) => response.data.boats as Boat[]));
  }

  getByFederalId(federalId: string): Observable<Customer> {
    return this.http
      .get(
        environment.apiHost + '/secure/customer/federal-id/' + federalId + '/'
      )
      .pipe(map((response: any) => response.data.customer as Customer));
  }

  getByboatId(boatId: number): Observable<any> {
    return this.http
      .get(environment.apiHost + '/secure/customers/boat/' + boatId)
      .pipe(map((response: any) => response.data.customers as any[]));
  }

  create(customer: Customer): Observable<Customer> {
    return this.http
      .post(environment.apiHost + '/secure/customer/', customer)
      .pipe(map((response: any) => response.data.customer));
  }

  update(customer: Customer): Observable<Customer> {
    return this.http
      .put(environment.apiHost + '/secure/customer/', customer)
      .pipe(map((response: any) => response.data.customer));
  }

  updateStatus(customerId: number, active: boolean): Observable<any> {
    return this.http
      .put(
        environment.apiHost + `/secure/customer/update-status/${customerId}`,
        active
      )
      .pipe(map((response: any) => response.data));
  }

  updateReviewed(customerId: number, reviewed: boolean): Observable<Customer> {
    return this.http
      .put(
        environment.apiHost + `/secure/customer/update-reviewed/${customerId}`,
        reviewed
      )
      .pipe(map((response: any) => response));
  }

  delete(id: number): Observable<Customer> {
    return this.http
      .delete(environment.apiHost + '/secure/customer/' + id)
      .pipe(map((response: any) => response.data.customer));
  }

  countCustomerWithNoGroup(): Observable<number> {
    return this.http
      .get(environment.apiHost + '/secure/customer/no-group')
      .pipe(map((response: any) => response.data.count as number));
  }

  countCustomersByGroup(groupId: number): Observable<number> {
    return this.http
      .get(environment.apiHost + '/secure/customer/count-group/' + groupId)
      .pipe(map((response: any) => response.data.count as number));
  }

  resolveFinancialBlock(body: {
    customerIds: number[];
    financialBlock: boolean;
  }): Observable<number> {
    return this.http
      .put(environment.apiHost + '/secure/customers/financial-block', body)
      .pipe(map((response: any) => response.data.count as number));
  }

  updateGroup(customerId: number, groupId: any): Observable<Customer> {
    return this.http
      .put(
        environment.apiHost + '/secure/customer/group/' + customerId,
        groupId
      )
      .pipe(map((response: any) => response.data.customer));
  }

  findByMarinaIdWithPagination(
    customerFilter: CustomerFilter
  ): Observable<any[]> {
    let params = new HttpParams();

    if (!customerFilter.sort || !customerFilter.order) {
      customerFilter.sort = 'name';
      customerFilter.order = 'ASC';
    }
    Object.keys(customerFilter).forEach((key) => {
      if (customerFilter[key] != null) {
        params = params.set(key, customerFilter[key]);
      }
    });
    params = params.set(
      'sort',
      customerFilter.sort.concat(',').concat(customerFilter.order)
    );
    params = params.set('page', customerFilter.page.toString());
    params = params.set('size', customerFilter.size.toString());
    return this.http
      .get(environment.apiHost + '/secure/customers/pagination', { params })
      .pipe(map((response: any) => response as any));
  }


  getOwnersAndAuthorizeds(): Observable<any> {
    return this.http.get(
      environment.apiHost + '/api-customer/customer/owners-and-authorizeds'
    );
  }

  uploadLicence(files: any[]): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('attachment', files[0]);
    let hd = new HttpHeaders();
    hd = hd.set('Content-Type', 'multipart/form-data');
    const options = {
      headers: hd,
    };
    return this.http
      .post(
        environment.apiHost + '/secure/customers/licence-file/attachment',
        formData,
        options
      )
      .pipe(map((response: any) => response.data.attachment));
  }

  findInactiveCustomersInMarine(): Observable<any> {
    return this.http
      .get(
        environment.apiHost + '/secure/customers/filter-list/inactive-status'
      )
      .pipe(map((response: any) => response.data.customers));
  }

  getCustomersToSaveAsDependent(): Observable<any> {
    return this.http
        .get(
            `${environment.apiHost}/api-customer/customer/dependents`
        )
        .pipe(map((response: any) => response as any));
  }

  getAllNotBlock(): Observable<any[]> {
    return this.http
      .get(environment.apiHost + '/secure/customernotblock/findmarina')
      .pipe(map((response: any) => response.data.customersnotblock as any[]));
  }

  deleteList(id: any): Observable<any> {
    return this.http
      .delete(environment.apiHost + '/secure/customernotblock/' + id)
      .pipe(map((response: any) => response.data.confirme as any[]));
  }

  startAutomaticNotBlock(): Observable<any> {
    return this.http
      .get(environment.apiHost + '/secure/customernotblock/execblock')
      .pipe(map((response: any) => response.data.confirme as any));
  }

  getCustomerDependents(customerId: number): Observable<any[]> {
    return this.http
      .get(`${environment.apiHost}/secure/customer/dependents/${customerId}`)
      .pipe(map((response: any) => response.data.dependents as any[]));
  }

  //daniel
  getCustomerDependentsByMarina(): Observable<any[]> {
    return this.http
      .get(`${environment.apiHost}/api-core/secure/reports/dependents`)
      .pipe(map((response: any) => response as any[]));
  }

  addDependentToCustomer(
    customerDependentDTO: CustomerDependentDTO
  ): Observable<any> {
    return this.http
      .post(
        `${environment.apiHost}/secure/customer/dependents`,
        customerDependentDTO
      )
      .pipe(map((response: any) => response));
  }

  deleteDependentFromMainCustomer(
    dependentCustomerId: number
  ): Observable<any> {
    return this.http
      .delete(
        `${environment.apiHost}/secure/customer/dependents/${dependentCustomerId}`
      )
      .pipe(map((response: any) => response));
  }

  updateDependentEmitirConvite(
    dependentCustomerId: number,
    emitirConvite: boolean
  ): Observable<any> {
    return this.http
      .put(
        `${environment.apiHost}/secure/customer/dependents/${dependentCustomerId}/emitir-convite`,
        { emitir_convite: emitirConvite }
      )
      .pipe(map((response: any) => response));
  }

  getCustomerPropertiesToInvite(): Observable<any[]> {
    return this.http
      .get(
        `${environment.apiHost}/api-core/secure/securities-property/invite-customer`
      )
      .pipe(map((response: any) => response as any[]));
  }

  listCustomerToInviteWithFilter(searchText: string, tipoBusca: string = 'NOME'): Observable<any[]> {
    let params = new HttpParams().set('search', searchText);
    params = params.set('tipoBusca', tipoBusca);
    return this.http
      .get(
        `${environment.apiHost}/api-core/secure/securities-property/invite-customer/search`,
        { params }
      )
      .pipe(map((response: any) => response as any[]));
  }

  getCustomerToFastEdit(search: string): Observable<any[]> {
    return this.http
      .get(
        `${environment.apiHost}/api-core/secure/customer/get-customer-to-fast/` +
          search
      )
      .pipe(map((response: any) => response as any[]));
  }

  saveFastEdit(form: any): Observable<any> {
    return this.http
      .post(
        `${environment.apiHost}/api-core/secure/customer/save-fast-edit`,
        form
      )
      .pipe(map((response: any) => response as any));
  }

  getAllCustomers(): Observable<any> {
    return this.http
      .get<any>(`${environment.apiHost}/api-customer/customer`)
      .pipe(map((response: any) => response));
  }


  printCustomerFile(id: number) {
    return this.http
      .get(environment.apiHost + '/secure/customer/print/' + id, {
        responseType: 'blob',
      })
      .pipe(map((res: any) => res));
  }

  createCustomerBasicInfo(form: any): Observable<any> {
    return this.http
      .post(
        `${environment.apiHost}/api-customer/customer/create-customer-basic-info`,
        form,
        { responseType: 'text' }
      )
      .pipe(map((response: any) => response as any));
  }

  getAllByEmailAndMarinaId(body: String, customerId: number): Observable<String> {
    const path = customerId ? customerId.toString() : "";
    return this.http
        .put(environment.apiHost + `/secure/customer/check-email/${path}`, body)
        .pipe(map((response: any) => response.data.customer));
  }

  getCustomerById(id: number): Observable<any> {
    return this.http
      .get(
        `${environment.apiHost}/api-customer/customer/${id}`
      )
      .pipe(map((response: any) => response as any));
  }

  put(id: string, payload: any): Observable<any> {
    return this.http.put(
      `${environment.apiHost}/api-customer/customer/${id}`,
      payload,
      { responseType: 'text' }
    ).pipe(
      map((response: any) => response),
      catchError(error => {
        console.error('Erro na atualização do cliente:', error);
        return throwError(() => error);
      })
    );
  }

  createLicense(customerId: number, payload: any): Observable<any> {
    return this.http.post(
      `${environment.apiHost}/api-customer/customer/${customerId}/license`,
      payload,
      { responseType: 'text' }
    ).pipe(map((response: any) => response as any));
  }

  updateLicense(customerId: number, licenseId: number, payload: any): Observable<any> {
    return this.http.put(
      `${environment.apiHost}/api-customer/customer/${customerId}/license/${licenseId}`,
      payload,
      { responseType: 'text' }
    ).pipe(
      map((response: any) => response),
      catchError(error => {
        console.error('Erro na atualização da licença:', error);
        return throwError(() => error);
      })
    );
  }

  saveBillingInfo(customerId: number, payload: any): Observable<any> {
    return this.http.post(
      `${environment.apiHost}/api-customer/customer/billing/${customerId}`,
      payload
    ).pipe(
      map((response: any) => response?.data ?? response),
      catchError(error => {
        console.error('Erro ao salvar informações de faturamento:', error);
        return throwError(() => error);
      })
    );
  }

  saveCustomerAdditionalInfo(customerId: number, payload: any): Observable<any> {
    const processedPayload = {};

    Object.keys(payload).forEach(key => {
      processedPayload[key] = (payload[key] === '' || payload[key] === undefined) ? null : payload[key];
    });

    return this.http.post(
      `${environment.apiHost}/api-customer/customer/${customerId}/additional-info`,
      processedPayload,
      { responseType: 'text' }
    ).pipe(
      map((response: any) => response as any),
      catchError(error => {
        console.error('Erro ao salvar informações adicionais do cliente:', error);
        return throwError(() => error);
      })
    );
  }
}

function throwError(arg0: () => any): any {
  throw new Error('Function not implemented.');
}

function tap(arg0: (response: any) => void): import("rxjs").OperatorFunction<import("@angular/common/http").HttpResponse<any>, any> {
  throw new Error('Function not implemented.');
}

